import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UpdateRequiredModalComponent } from './update-required-modal.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        TranslateModule,
        FormsModule
    ],
    declarations: [UpdateRequiredModalComponent]
})
export class UpdateRequiredModalModule { }
